import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from '@app/store';
import {
  fetchDocumentById,
  createDocument,
  updateDocument,
  DocumentActions,
} from "./DocumentSlice";
import { fetchAffiliates } from "../affiliate/AffiliateSlice";
import { fetchUserProfile } from "../auth/authSlice";
import { DocumentMapper } from "./DocumentMapper";
import { DocumentOutputDTO } from './types';
import { AffiliateOutputDTO } from "../affiliate/types";
import { DataForm } from '@components/ui';
import { Field } from '@components/ui/DataForm';
import { FormSkeleton } from '@components/ui/FormSkeleton';
import { ApiError } from '@/types/api';
import { useNotification } from '@hooks/useNotification';
import { Box, Typography, Alert } from "@mui/material";
import { useAuth } from '@hooks/useAuth';
import { UserDocument } from "../user";
import { fetchCategoryDocuments } from "../categorydocument";

const DocumentForm: React.FC = (props:any) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { currentItem, loading } = useSelector(
    (state: RootState) => state.document
  );
  const { items: affiliates, loading: affiliatesLoading } = useSelector(
    (state: RootState) => state.affiliate
  );

  const { items:categories, loading:loading_categories, error:error_categories } = useSelector((state: RootState) => {
      // console.log('🔍 Selector executando, loading:', state.categorydocument.loading);
      return state.categorydocument;
    });
  // Get current document info from auth state
  const { user, isAuthenticated } = useAuth();
  const [formData, setFormData] = useState<Partial<DocumentOutputDTO>>({});
  const [formError, setFormError] = useState<ApiError | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const notification = useNotification();

  const isLoadingRef = useRef(false);
  const initialLoadDoneRef = useRef(false);
  const submitAttemptRef = useRef(false);

  // Make sure we have the current document data
  useEffect(() => {
    if (isAuthenticated && !user) {
      console.log("🔄 Fetching current document profile");
      dispatch(fetchUserProfile());
    }
  }, [dispatch, isAuthenticated, user]);

  // Debug output for current document
  useEffect(() => {
    console.log("🧪 Current authenticated document:", user);
  }, [user]);

  // Document document-based access control
 

  useEffect(() => {
    const loadData = async () => {
      if (isLoadingRef.current || initialLoadDoneRef.current) {
        return;
      }
      await dispatch(fetchCategoryDocuments({}));

      try {
        console.log("📡 Iniciando carregamento do Usuário:", id);
        isLoadingRef.current = true;

        // Load affiliates
        console.log("📡 DocumentForm - Carregando Afiliados");
        await dispatch(fetchAffiliates({}));

        if (id && props.onClose==undefined) {
          console.log("📡 DocumentForm - Carregando Usuário:", id);
          const resultAction = await dispatch(fetchDocumentById(id));

          if (fetchDocumentById.fulfilled.match(resultAction)) {
            console.log("✅ Usuário carregado com sucesso");
          } else {
            throw new Error("Erro ao carregar dados");
          }
        }
      } catch (error) {
        console.error("❌ Erro ao carregar Usuário:", error);
        notification.showError("Erro ao carregar dados");
        setFormError({
          message: "Erro ao carregar dados",
          code: "LOAD_ERROR",
          statusCode: 500,
        });
      } finally {
        isLoadingRef.current = false;
        initialLoadDoneRef.current = true;
        setIsInitialLoad(false);
      }
    };

    loadData();

    return () => {
      console.log("🧹 Limpando estado do formulário");
      dispatch(DocumentActions.clearCurrentItem());
    };
  }, [dispatch, id, notification]);

  useEffect(() => {
    if (currentItem) {
      console.log("📝 Document - Atualizando dados do formulário:", currentItem);
      setFormData({
        name: currentItem.name,
        category: currentItem.category ?? '',
        enterpriseId: currentItem.enterpriseId,
      });
    }
  }, [currentItem]);
  console.log('formdata',formData)

  useEffect(() => {
      console.log('atualizou', fields)
      setFields(fields.map((item: any) => {
        if (item.name == 'category') {
          item.options = categories.filter((item) => item.type == 'document').map((affiliate: AffiliateOutputDTO) => ({
            value: affiliate._id || "",
            label: affiliate.name || "Sem nome",
          }));
  
        }
        return item;
      }))
    }, [categories])
  // Filter available document options based on current document's document
  

  // Determine if enterprise_id field should be disabled
  const isEnterpriseIdDisabled = () => {
    // Only ADMIN can modify enterprise_id
    return loading_categories
  };

  const [fields, setFields] = useState<any>([
    {
      name: "name",
      label: "Nome",
      type: "text",
      required: true,
      validationError: formError?.validationErrors?.name?.message,
    },
   
    {
      name: "category",
      label: "Categoria",
      type: "select",
      required: true,
      disabled: isEnterpriseIdDisabled(),
      options: categories.filter((item)=>item.type=='document').map((affiliate: AffiliateOutputDTO) => ({
        value: affiliate._id || "",
        label: affiliate.name || "Sem nome",
      })),
      validationError: formError?.validationErrors?.category?.message,
    },
  ]);

  const handleSubmit = async (data: Partial<DocumentOutputDTO>) => {
    if (submitAttemptRef.current) {
      notification.showWarning("Submissão em andamento, aguarde...");
      return;
    }
    console.log(formData)
    try {
      submitAttemptRef.current = true;
      setIsSubmitting(true);
      setFormError(null);
      // If password is empty in edit mode, remove it from the payload
      
      // If the document is a Manager trying to create an Admin, prevent it

      // If the document is a Manager, keep the existing enterpriseId or set the current document's enterpriseId
      // if (currentDocumentDocument === UserDocument.ADMIN || currentDocumentDocument === UserDocument.SUPER || currentDocumentDocument === UserDocument.MANAGER) {
      //   if (id && formData.enterpriseId) {
      //     // Keep the original enterprise ID when editing
      //     data.enterpriseId = formData.enterpriseId;
      //   } else if (!id) {
      //     // Set the manager's own enterprise ID for new documents
      //     data.enterpriseId = document?.enterpriseId;
      //   }
      // }
      data.enterpriseId=user?.enterpriseId;

      const mappedData = DocumentMapper.toDTO(data);
      console.log("📤 Enviando dados:", mappedData);

      const resultAction = (id && props.onClose==undefined)
        ? await dispatch(updateDocument({ id, data: mappedData }))
        : await dispatch(createDocument(mappedData));

      if (
        updateDocument.rejected.match(resultAction) ||
        createDocument.rejected.match(resultAction)
      ) {
        const error = resultAction.payload as ApiError;
        setFormError(error);
        notification.showError(error.message || "Erro ao salvar dados");
        return;
      }

      notification.showSuccess("Dados salvos com sucesso!");
      if(props.onClose){
        props.onClose();
      }
      else{
        navigate("/documents");
      }
    } catch (error) {
      console.error("❌ DocumentForm - Erro inesperado:", error);
      notification.showError("Erro inesperado ao salvar os dados");
      setFormError({
        code: "UNKNOWN_ERROR",
        message: "Erro inesperado ao salvar os dados",
        statusCode: 500,
      });
    } finally {
      setIsSubmitting(false);
      submitAttemptRef.current = false;
    }
  };

  // Return nothing if document is a lawyer (will be redirected)
  // if (currentDocumentDocument === UserDocument.LAWYER) {
  //   return null;
  // }

  if (isInitialLoad && (loading || affiliatesLoading)) {
    return <FormSkeleton fields={6} />;
  }

  return (
    <Box sx={{ p: 0 }}>
      {/* <Typography variant="h5" gutterBottom>
        {id ? "Editar Função" : "Nova Função"}
      </Typography> */}
      
      {/* {currentDocumentDocument === UserDocument.MANAGER && (
        <Alert severity="info" sx={{ mb: 3 }}>
          Como gerente, você não pode criar usuários administradores nem alterar a empresa vinculada ao usuário.
        </Alert>
      )} */}
      
      <DataForm
        data={formData}
        onClose={props.onClose}
        fields={fields}
        isEdit={id!=undefined}

        onSubmit={handleSubmit}
        basePath="documents"
        title={id ? "Editar Tipo de Documento" : "Novo Tipo de Documento"}
        error={formError}
        onClearError={() => setFormError(null)}
        disabled={isSubmitting}
      />
    </Box>
  );
};

export default DocumentForm;
